// @ts-nocheck

import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { hideChangeLog } from '@/actions/changelogActions';
import { getShowChangelog, getShowChangelogFilterLevel } from '@/selectors';

import ChangelogBody from './ChangelogBody';
import { CURRENT_VERSION, getFilteredChangelog, WHATS_NEW_STORE_NAME } from './ChangelogStaticContent';

const getFooterContent = handleDialogHide => (
    <Button onClick={handleDialogHide}>
        <FormattedMessage id='intl-msg:changelog.close' />
    </Button>
);

const ChangelogComponentWithoutInjection = ({ handleDialogHide, show, filterLevel }) => (
    <Dialog
        show={show}
        title={<FormattedMessage id='intl-msg:changelog.whatsNew' />}
        body={<ChangelogBody entries={getFilteredChangelog(filterLevel)} />}
        onClose={handleDialogHide}
        useOverflow
        showCloseButton
        footer={getFooterContent(handleDialogHide)}
    />
);

ChangelogComponentWithoutInjection.propTypes = {
    handleDialogHide: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    filterLevel: PropTypes.string.isRequired,
};

const ChangelogComponent = props => {
    const dispatch = useDispatch();
    const show = useSelector(getShowChangelog);
    const filterLevel = useSelector(getShowChangelogFilterLevel);

    const handleDialogHide = () => {
        window.localStorage.setItem(WHATS_NEW_STORE_NAME, CURRENT_VERSION);
        dispatch(hideChangeLog());
    };

    return (
        <ChangelogComponentWithoutInjection
            {...props}
            handleDialogHide={handleDialogHide}
            show={show}
            filterLevel={filterLevel}
        />
    );
};

export default injectIntl(ChangelogComponent);
